<template>
  <div class="authenticating">
    Authenticating...
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import router from '@/router'

export default {
  name: 'Auth',
  methods: mapActions('auth', ['handleAuthentication']),
  data () {
    this.handleAuthentication()
    router.push({ name: 'Home' })

    return {}
  }
}
</script>
